import { render, staticRenderFns } from "./ListObservacionesWebApp.vue?vue&type=template&id=1fb776b1&"
import script from "./ListObservacionesWebApp.vue?vue&type=script&lang=js&"
export * from "./ListObservacionesWebApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports